export default __webpack_public_path__ + "static/media/FAVICON_53.9f6502db.png";